import React from 'react';
import Header from './components/Header.tsx';
import Hero from './components/Hero.tsx';
import Features from './components/Features.tsx';
import Screenshots from './components/Screenshots.tsx';
import FAQ from './components/FAQ.tsx';
import Footer from './components/Footer.tsx';
import GoogleAnalytics from './components/GoogleAnalytics.tsx';
import './App.css';

const App: React.FC = () => {
  return (
    <div className="App">
      <GoogleAnalytics />
      <Header />
      <main>
        <Hero />
        <Features />
        <Screenshots />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
};

export default App;
